import { render, staticRenderFns } from "./zfKanBan.vue?vue&type=template&id=26a65ae0&scoped=true&"
import script from "./zfKanBan.vue?vue&type=script&lang=js&"
export * from "./zfKanBan.vue?vue&type=script&lang=js&"
import style0 from "./zfKanBan.vue?vue&type=style&index=0&id=26a65ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a65ae0",
  null
  
)

export default component.exports